const isSuperUser = email =>
  [
    "mwalker@cromwell.co.uk",
    "jwilliams@cromwell.co.uk",
    "claire.cobb@cromwell.co.uk",
    "archerp@cromwell.co.uk"
  ].includes(email.toLowerCase());

export default isSuperUser;
